var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C3.806 17 0 13.194 0 8.5S3.806 0 8.5 0 17 3.806 17 8.5 13.194 17 8.5 17zm0-2c3.59 0 6.5-2.91 6.5-6.5S12.09 2 8.5 2 2 4.91 2 8.5 4.91 15 8.5 15z",
    transform: "translate(-922 -7935) translate(877 7835) translate(45 100) translate(5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.762 15.176l3.056 3.056c.39.39 1.023.39 1.414 0 .39-.39.39-1.024 0-1.414l-3.056-3.056c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.023 0 1.414z",
    transform: "translate(-922 -7935) translate(877 7835) translate(45 100) translate(5 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7c62f24aeaab9406de976d8f2c265253.svg";
export { ForwardRef as ReactComponent };